import { createStyles, makeStyles } from "@material-ui/core";
import { UIKIT_COLORS } from "../../theme/colors";

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      position: "relative",
      width: "100%",
      borderRadius: 8,
      overflow: "hidden",
      backgroundColor: UIKIT_COLORS.BG_DOC,
      userSelect: "none",
    },
    imageWrap: {
      width: "100%",
      overflow: "hidden",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "zoom-in",
      "& img": {
        width: "100%",
        height: "auto",
        maxHeight: "70vh",
        objectFit: "contain",
        display: "block",
        transition: "transform 0.25s ease",
      },
    },
    imageWrapZoomed: {
      cursor: "zoom-out",
    },
    imgZoomed: {
      transform: "scale(2.5)",
    },
    arrowBtn: {
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      backgroundColor: `${UIKIT_COLORS.OVERLAY_UI} !important`,
      "&:hover": { backgroundColor: `${UIKIT_COLORS.OVERLAY_UI_HOVER} !important` },
      "&:disabled": { opacity: 0.3 },
      padding: 4,
    },
    arrowLeft: { left: 8 },
    arrowRight: { right: 8 },
    count: {
      position: "absolute",
      bottom: 10,
      right: 12,
      backgroundColor: UIKIT_COLORS.OVERLAY_BG,
      color: UIKIT_COLORS.WHITE,
      fontSize: 11,
      fontWeight: 600,
      lineHeight: "16px",
      padding: "2px 8px",
      borderRadius: 10,
    },
  })
);
